import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SharedService } from 'src/app/shared/shared.service';
import { ProgramBuilderMainService } from '../../program-builder-main.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { getDownloadURL, getStorage } from '@angular/fire/storage';
import { ref, uploadBytesResumable } from 'firebase/storage';
import { DomSanitizer } from '@angular/platform-browser';
import { PdfModalComponent } from '../pdf-modal/pdf-modal.component';
import { Subscription } from 'rxjs';
import { ParallelUploadService } from 'src/app/shared/services/parallel-upload.service';

@Component({
  selector: 'app-program-item-details',
  templateUrl: './program-item-details.component.html',
  styleUrls: ['./program-item-details.component.scss']
})
export class ProgramItemDetailsComponent implements OnInit {
	action: string = "";
	type: string = "";
	actionCamelCase: string = "";
	typeCamelCase: string = "";
	itemCopy: any;
	videosityCategories: any = [];
	videosityCourses: any = [];
	unitTypes = ["video", "videosity unit", "quiz", "ispring quiz", "download"];
	blockLoader: string = 'blockLoader';
	programId: any;
	sectionIndex: any;
	unitIndex: any;
	uploadProgress: number = 0;
	programDetailsSubscription:Subscription | undefined;

	constructor(
		private snackbar: MatSnackBar,
		private sharedService: SharedService,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<ProgramItemDetailsComponent>,
		private programBuilderMainService: ProgramBuilderMainService,
		private spinner: NgxSpinnerService,
		private sanitizer: DomSanitizer,
		private dialog: MatDialog,
		private parallelUploadService: ParallelUploadService
	) {
		this.action = this.data.action;
		this.actionCamelCase = this.action.charAt(0).toUpperCase() + this.action.slice(1);
		this.type = this.data.type;
		this.typeCamelCase = this.type.charAt(0).toUpperCase() + this.type.slice(1);
		this.videosityCategories = this.data.videosityCategories;
		this.programId = this.data.programDetails.id;
		this.sectionIndex = this.data.programDetails.sectionIndex;
		this.unitIndex = this.data.programDetails.unitIndex;

		if (this.data.itemCopy) {
			this.itemCopy = structuredClone(this.data.itemCopy);
			if((this.itemCopy.type==='download' && this.itemCopy.metadata.documents[0].link) || (this.itemCopy.type==='video' && this.itemCopy.metadata.topics[0].videoLocation) || (this.itemCopy.quizType==='ispring quiz'  && this.itemCopy.questionsZipFile)) {
				this.uploadProgress = 100;
			}
		} else {
			this.itemCopy = {
				name: ""
			};

			if (this.type === "section") {
				this.itemCopy.description = "";
				this.itemCopy.menu = [];
			} else if (this.type === "unit") {
				this.itemCopy.pts = 0;
				this.itemCopy.dfs = 0;
				this.itemCopy.type = "";
				this.itemCopy.metadata = {};
			}
		}
	}

	sanitizePdfUrl (url:any) {
		return this.sanitizer.bypassSecurityTrustResourceUrl(url)
	}

	async ngOnInit() {
		if (this.itemCopy.type === "quiz" || this.itemCopy.type === "Quiz" || (this.itemCopy.type === "video" && this.itemCopy.videoType !== "standard video")) {
			await this.getVideosityCourses(this.itemCopy.categoryId);
		}
		this.getProgramDetails();
	}

	// shouldInputBeDisabled() {
	// 	return true ? this.action === "edit" : false;
	// }

	shouldInputBeDisabled() {
		if (this.action === "edit") {
			if (this.itemCopy.type === '') {
				return false;
			} else {
				return true;
			}
		} else {
			return false;
		}
	}

	newUnitChangeType(unitType: string) {
		this.itemCopy.type = unitType;

		if (unitType !== "video") {
			delete this.itemCopy.videoType;
		}

		if (unitType === "video") {
			this.itemCopy.videoType = "standard video";
			this.addTopicToUnit();
		}

		if (unitType === "download") {
			this.itemCopy.metadata.documents = [{
				link: "",
				portraitImage: "",
				landscapeImage: ""
			}];
		}
		if(unitType === "ispring quiz") {
			this.itemCopy.quizType = "ispring quiz"
		}else {
			delete this.itemCopy.quizType;
		}
	}

	areItemDetailsValid() {
		// For sections
		if (this.type === "section") {
			if (!this.itemCopy.name || this.itemCopy.name.length <= 0 || !this.itemCopy.description || this.itemCopy.description.length <= 0) {
				return false;
			}
		} else if (this.type === "unit") {
			// For units
			if (!this.itemCopy.name || !this.itemCopy.type || !this.itemCopy.metadata) {
				return false;
			}

			// For quiz
			if (this.itemCopy.type === "quiz") {
				if (!this.itemCopy.categoryId || !this.itemCopy.courseid) {
					return false;
				}
			}

			// For both video unit types
			if (this.itemCopy.type === "video") {
				if (!this.itemCopy.metadata.topics) {
					return false;
				}

				for (let topic of this.itemCopy.metadata.topics) {
					if (!topic.id || !topic.thumbnailSource || !topic.videoLocation || !topic.videoDuration) {
						return false;
					}
				}
			}

			// For old video type unit
			if (this.itemCopy.type === "video" && this.itemCopy.videoType !== "standard video") {
				if (!this.itemCopy.categoryId || !this.itemCopy.courseid) {
					return false;
				}
			}

			// For new video type unit
			if (this.itemCopy.type === "video" && this.itemCopy.videoType === "standard video") {}

			// For download type unit
			if (this.itemCopy.type === "download") {
				if (!this.itemCopy.metadata.documents) {
					return false;
				}

				for (let document of this.itemCopy.metadata.documents) {
					if (!document.link) {
						return false;
					}
				}
			}
		}

		return true;
	}

	async changeCategoryType(categoryId: any) {
		this.itemCopy.categoryId = categoryId;
		this.itemCopy.courseid = "";
		this.itemCopy.metadata = "";
		await this.getVideosityCourses(categoryId);
	}

	changeCourseType(courseId: any) {
		this.itemCopy.courseid = courseId;
		const selectedCourse = this.videosityCourses.find((course: any) => {
			return course.courseid === courseId;
		});

		if (selectedCourse.coverImg) {
			selectedCourse.coverImg = `https://s3-ap-southeast-2.amazonaws.com/${selectedCourse.coverImg}`;
		}
		// console.log(selectedCourse);

		this.itemCopy.metadata = selectedCourse;
	}

	async getVideosityCourses(categoryId: string) {
		const coursesObs = this.programBuilderMainService.getIgnite(categoryId);
		const coursesData: any = await this.sharedService.getObservableRes(coursesObs);
		if (coursesData.success) {
			this.videosityCourses = coursesData.courses;
		}
	}

	cleanItemCopy() {
		if (this.type === "unit") {
			if (this.itemCopy.type === "videosity unit") {
				this.itemCopy.type = "video";
			}

			if (this.itemCopy.type === "quiz" || this.itemCopy.type === "video") {
				delete this.itemCopy.downloadUrl;
			}

			if (this.itemCopy.type !== "video" && this.itemCopy.type !== "quiz") {
				delete this.itemCopy.metadata.topics;
			}

			if (this.itemCopy.type === "download") {
				delete this.itemCopy.categoryId;
				delete this.itemCopy.courseid;
			}

			if (this.itemCopy.type === "ispring quiz") {
				this.itemCopy.type = "quiz";
			}

			this.itemCopy.pts = Number(this.itemCopy.pts);
		}
	}

	removeTopicFromUnit(topicIndex: number) {
		this.itemCopy.metadata.topics.splice(topicIndex, 1);
	}

	addTopicToUnit() {
		if (!this.itemCopy.metadata) {
			this.itemCopy.metadata = {};
		}

		if (!this.itemCopy.metadata.topics) {
			this.itemCopy.metadata.topics = [];
		}

		// this.itemCopy.metadata.topics.push({
		// 	id: `${this.sectionIndex}${this.unitIndex}${this.itemCopy.metadata.topics.length}`,
		// 	name: "",
		// 	thumbnailSource: "",
		// 	videoDuration: "",
		// 	videoLocation: ""
		// });
		this.itemCopy.metadata.topics[0] = {
			id: `${this.sectionIndex}${this.unitIndex}${this.itemCopy.metadata.topics.length}`,
			name: "",
			thumbnailSource: "",
			videoDuration: "",
			videoLocation: ""
		};
	}

	closeModal(action: string) {
		if (action === "cancel") {
			if(this.action==="edit" && this.itemCopy?.type==='quiz' && this.itemCopy?.quizType==='ispring quiz') {
                const updatedItemCopyData = {...this.data.itemCopy, quizDeployment: this.itemCopy.quizDeployment }
                this.dialogRef.close({status: "cancel", data: updatedItemCopyData});
            }else{
                this.dialogRef.close({
					status: "cancel"
				});
            }
		} else if (action === "save") {
			this.cleanItemCopy();
			// let isValid = this.areItemDetailsValid();
			let isValid = true;

			if (!isValid) {
				this.snackbar.open(`Please fill all ${this.type} details`, "OK", {
					duration: 3000
				});
			} else {
				this.dialogRef.close({
					status: "success",
					data: this.itemCopy
				});
			}
		}
	}

	async chooseFileForUploading(event: any, unitType: string, contentType: string, imageType: string, topicIndex?: any) {
		const file = event.target.files[0];
		let fileSavingLocation = "";

		if (unitType === "video") {
			if (contentType === "video") {
				fileSavingLocation = `programs/${this.programId}/videos/video-${this.sectionIndex}-${this.unitIndex}-${topicIndex}.mp4`;
			} else if (contentType === "image") {
				if (file.size > 1048576) {
					this.snackbar.open("File size must not exceed 1 MB.", "OK", {
						duration: 3000
					});
					event.target.value = null;
					return;
				}
				fileSavingLocation = `programs/${this.programId}/images/image-${this.sectionIndex}-${this.unitIndex}-${topicIndex}.mp4`;
			}
		} else if (unitType === "download") {
			if (contentType === "file") {
				fileSavingLocation = `documents/${file.name}`;
			} else if (contentType === "image") {
				if (file.size > 1048576) {
					this.snackbar.open("File size must not exceed 1 MB.", "OK", {
						duration: 3000
					});
					event.target.value = null;
					return;
				}
				// changed imageType based on image height and width
				imageType = await this.getImageType(file);
				console.log('imageType:', imageType);

				if (imageType === "portrait") {
					fileSavingLocation = `download/portrait/${this.programId}/images/image-${this.sectionIndex}-${this.unitIndex}.png`;
				} else if (imageType === "landscape") {
					fileSavingLocation = `download/portrait/${this.programId}/images/image-${this.sectionIndex}-${this.unitIndex}.png`;
				}
			}
		}

		let uploadedFileUrl;
		if ((unitType === "video" && contentType === "video") || (unitType === "download" && contentType === "file")) {
			uploadedFileUrl = await this.getUrlForUploadedVideoRes(file, fileSavingLocation);
		} else {
			await this.spinner.show("blockLoader");
			uploadedFileUrl = await this.sharedService.getUrlForUploadedVideo(file, fileSavingLocation);
			await this.spinner.hide("blockLoader");
		}
		event.target.value = null;

		if (unitType === "video") {
			if (contentType === "video") {
				this.itemCopy.metadata.topics[topicIndex].videoLocation = uploadedFileUrl;
				const videoDuration = String(String(await this.getVideoDuration(file)).split(".")[0]);
				this.itemCopy.metadata.topics[topicIndex].videoDuration = videoDuration;
			} else if (contentType === "image") {
				this.itemCopy.metadata.topics[topicIndex].thumbnailSource = uploadedFileUrl;
			}
		} else if (unitType === "download") {
			if (contentType === "file") {
				this.itemCopy.metadata.documents[0].link = uploadedFileUrl;
			} else if (contentType === "image") {
				if (imageType === "portrait") {
					this.itemCopy.metadata.documents[0].portraitImage = uploadedFileUrl;
				} else if (imageType === "landscape") {
					this.itemCopy.metadata.documents[0].landscapeImage = uploadedFileUrl;
				}
			}
		}
	}

	async getUrlForUploadedVideoRes(file: any, route: string) {
		// Use parallel chunked upload for large files (> 50 MB) for 2–3× faster speeds.
		const PARALLEL_THRESHOLD = 50 * 1024 * 1024; // 50 MB

		if (file.size > PARALLEL_THRESHOLD) {
			try {
				const url = await this.parallelUploadService.uploadFileInParallel(
					file,
					route,
					(progress) => {
						this.uploadProgress = progress.percent;
					}
				);
				return url;
			} catch (e) {
				console.warn('Parallel chunk upload failed, falling back to standard upload:', e);
				this.uploadProgress = 0;
			}
		}

		// Standard single-connection upload (used for files ≤ 50 MB or as fallback).
		return new Promise<string>(async (resolve) => {
			const storage = getStorage();
			const storageRef = ref(storage, route);

			const uploadTask = uploadBytesResumable(storageRef, file);
			uploadTask.on('state_changed', (snapshot) => {
				this.uploadProgress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
			}, (error) => {
				resolve("error in file upload");
			}, async () => {
				const imageUrl = await getDownloadURL(uploadTask.snapshot.ref);
				resolve(imageUrl);
			});

		}).catch(e => {
			console.log("getUrlForUploadedFile error: ", e);
			return '';
		});
	}

	getVideoDuration(file: any) {
		const url = URL.createObjectURL(file);

		return new Promise((resolve) => {
			const audio = document.createElement("audio");
			audio.muted = true;
			const source = document.createElement("source");
			source.src = url;
			audio.preload= "metadata";
			audio.appendChild(source);
			audio.onloadedmetadata = function() {
				resolve(audio.duration);
				URL.revokeObjectURL(url);
			};
			audio.load();
		});
	}

	removeImageFromUnit(unitType: string, type: string, topicIndex?: any) {
		if (unitType === "video") {
			this.itemCopy.metadata.topics[topicIndex].thumbnailSource = "";
		} else if (unitType === "download") {
			if (type === "portrait") {
				this.itemCopy.metadata.documents[0].portraitImage = "";
			} else if (type === "landscape") {
				this.itemCopy.metadata.documents[0].landscapeImage = "";
			}
		}
	}

	removeVideoFromUnit(unitType: string, topicIndex?: any) {
		if (unitType === "video") {
			this.itemCopy.metadata.topics[topicIndex].videoLocation = "";
			this.uploadProgress = 0;
		}
	}

	removeDocumentFromUnit(unitType: string, topicIndex?: any) {
		if (unitType === "download") {
			this.itemCopy.metadata.documents[0].link = "";
			this.uploadProgress = 0;
		}
	}

	getImageType(file: File): Promise<string> {
		return new Promise((resolve) => {
		  const reader = new FileReader();
		  const img = new Image();

		  reader.onload = (e: any) => {
			img.src = e.target.result;

			img.onload = () => {
			  const imageWidth = img.width;
			  const imageHeight = img.height;

			  if (imageHeight === imageWidth) {
				resolve("portrait");
			  } else {
				resolve("landscape");
			  }
			};
		  };

		  reader.readAsDataURL(file);
		});
	}

	openPdfModal(url:string) {
		const modal = this.dialog.open(PdfModalComponent, {
			data: {
				url
			},
			minWidth: '60%'
		})
	}

	async quizFileUploadHandler(event: any, type: string) {
		const file = event.target.files[0];
		if (!file) return; // Exit if no file is selected

		let fileSavingLocation = '';
		let uploadedFileUrl = '';

		const fileName = file.name;
    	const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
		if (type === 'sourcePptFile') {
			// Allow PowerPoint files only
			// if (!file.name.endsWith('.pptx')) {
			// 	this.snackbar.open("Please upload a valid PowerPoint file (.pptx)", "OK", {
			// 		duration: 3000
			// 	});
			// 	return;
			// }
			fileSavingLocation = `programs/${this.programId}/ispring-quizzes/quiz-${this.sectionIndex}-${this.unitIndex}.${fileExtension}`;
		} else if (type === 'questionsZipFile') {
			// Allow ZIP files only
			if (!file.name.endsWith('.zip')) {
				this.snackbar.open("Please upload a valid ZIP file (.zip)", "OK", {
					duration: 3000
				});
				return;
			}
			fileSavingLocation = `programs/${this.programId}/ispring-quizzes/quiz-${this.sectionIndex}-${this.unitIndex}.zip`;
		} else {
			this.snackbar.open("Invalid file type", "OK", {
				duration: 3000
			});
			return;
		}

		try {
			// await this.spinner.show('blockLoader');
			// uploadedFileUrl = await this.getUrlForUploadedVideoRes(file, fileSavingLocation);
			// await this.spinner.hide('blockLoader');

			if (type === 'sourcePptFile') {
				await this.spinner.show('blockLoader');
				uploadedFileUrl = await this.sharedService.getUrlForUploadedVideo(file, fileSavingLocation);
				await this.spinner.hide('blockLoader');
				
				this.itemCopy.sourcePptFile = uploadedFileUrl;
			} else if (type === 'questionsZipFile') {
				uploadedFileUrl = await this.getUrlForUploadedVideoRes(file, fileSavingLocation);
				
				this.itemCopy.questionsZipFile = uploadedFileUrl;
				this.itemCopy.quizUrl = "";
				this.itemCopy.quizDeployment = "processing";
			}
		} catch (error) {
			console.error('File upload failed:', error);
		} finally {
			event.target.value = null; // Reset file input
		}
		// console.log('item', this.itemCopy);
	}

	removeQuizHandler(type:string) {
		if(type==="sourcePptFile") {
			this.itemCopy.sourcePptFile = "";
		}else if(type==="questionsZipFile") {
			this.itemCopy.questionsZipFile = "";
			this.uploadProgress = 0;
		}
	}

	showVideoType(type:string) {
		// console.log('itemCopy: ', this.itemCopy);
		if(type==="video" && this.itemCopy.videoType!=="standard video") {
			return "videosity unit"
		}else if(type==="video" && this.itemCopy.videoType==="standard video") {
			return "video"
		}else if(type==="quiz" && this.itemCopy.quizType!=="ispring quiz") {
			return "quiz"
		}else if(type==="quiz" && this.itemCopy.quizType==="ispring quiz") {
			return "ispring quiz"
		}else {
			return type;
		}
	}

	getProgramDetails () {
        if(this.itemCopy.quizType==='ispring quiz') {
            this.programDetailsSubscription = this.programBuilderMainService.getProgramDetails(this.programId).subscribe(program => {
                // console.log('program: ', program);
                this.itemCopy = program.sections[this.sectionIndex].menu[this.unitIndex];
            })
        }
    }
    ngOnDestroy(): void {
        this.programDetailsSubscription?.unsubscribe();
    }

}
